import { useRef,  useState , memo , useCallback} from 'react';
import Map from '../components/map/Map.js'
import Grid from '@mui/material/Grid'

import {useFetchFlowers} from '../hooks/useFetchFlowers'
import {useFetchHistory} from '../hooks/useFetchHistory'
import {useFetchStation} from '../hooks/useFetchStation'
import {useFetchFacility} from '../hooks/useFetchFacility'
import {useFetchToilet} from '../hooks/useFetchToilet'
import {useFetchBarrierFrees} from '../hooks/useFetchBarrierFrees'
import {Marker ,  Tooltip} from 'react-leaflet'
import Header from "../components/Header";
import { useTranslation } from "react-i18next";
import {useSharedLang} from '../hooks/useSharedLang.js';
import {LANGS ,  MAPS , geoPositionOptions} from "../components/constants.js";
import {useGeolocated} from '../hooks/useGeolocated';
import {useDikstra} from '../hooks/useDikstra';
import Loading from "../components/Loading.js";
import {getIcon ,getTooltipOptions} from "../utils/UrlUtil.js";
import {AutumnIcon} from '../components/map/MapIcon.js'
import MapCardAudioGuide from '../components/map/MapCardAudioGuide.js'

const AudioGuide = memo(() => {
  const mapRef = useRef(null);
  const mapCardRef = useRef(null);

  //jsonデータを取得
  const {flowerList, isLoading:isLoadingFlowers} = useFetchFlowers();
  const {historyList, isLoading:isLoadingHistory} = useFetchHistory();
  const {stationList, isLoading:isLoadingStation} = useFetchStation();
  const {facilityList, isFacilityLoading} = useFetchFacility(); 
  const {toiletList, isToiletLoading} = useFetchToilet(); 
  const {dataList:barrierFreeList, isLoading:isLoadingBarrierFrees} = useFetchBarrierFrees();

  const { getDistance } = useDikstra({})

  const activeAudioGuideList = useRef(null);
  //選択されているデータ
  const [selectedData , setSelectedData] = useState(null);
  //選択されているマーカーの識別子（データID＋座標）※1つのデータに複数座標あるので座標情報含めてマーカーは一意
  const selectedMarkerKey = useRef(null);



  //--- 多言語対応 ---
  const { t } = useTranslation();
  const { sharedLang } = useSharedLang();

  /**
   * リアルタイム座標チェック
   * 
   * @param {*} pos 
   */
  const setCurrentPosition = (pos) => {
    if(mapRef.current == null){
      return;
    }
    //現在地をマップに表示
    mapRef.current.updateMarker(pos.coords.latitude, pos.coords.longitude);
    lastCoords.current =  pos;
    //自動音声ガイド
    if(mapCardRef != null && !mapCardRef.current.isPlayingSound()){
      activeAudioGuideList.current.map((element, fIndex) =>
        element.positions.map((position, pIndex) => {
            if(getDistance(
                pos.coords.latitude , pos.coords.longitude , 
                position.latitude, position.longitude) <= MAPS.AUTO_POPUP_DISTANCE){
                    clickMarker(element , position);
            }
        }
      ));
    }
  };
  //--- 現在地 ---
  //useGeolocated の coordsは使わない。使うと座標が更新されるたびに画面が再描写してしまう。
  const { isGeolocationAvailable, isGeolocationEnabled  } = useGeolocated({
      ...geoPositionOptions , 
      onSuccess : (pos) => setCurrentPosition(pos),
  });
  const lastCoords = useRef(null);

  const isPlayingSound = (isPlaying) => {
      return isPlaying;
  }

  const isActiveMarker = useCallback((markerkey , caterogy) => {
    if(['history' , 'station' , 'restaurant'].includes(caterogy) 
      && !selectedMarkerKey.current){
      return true;
    } 
    return selectedMarkerKey.current === markerkey;
  },[]);


  const getMarkerKey = useCallback((flower , coordinate) => {
    return flower.id + '-' + coordinate[0] + '-' + coordinate[1];
  },[]);

  const clickMarker = (row, coordinate) => {
    selectedMarkerKey.current = getMarkerKey(row, coordinate);
    setSelectedData(row);
  };

  const resetMarker = useCallback(() => {
    selectedMarkerKey.current = null;
    setSelectedData(null);
  },[]);
  

  const getActiveDataList = () => {
    let elements = [];
    let allList = flowerList.concat(flowerList)
                            .concat(historyList)
                            .concat(stationList)
                            .concat(facilityList)
                            .concat(toiletList)
                            .concat(barrierFreeList);

    for (let index = 0; index < allList.length; index++) {
      let row = allList[index];
      if(sharedLang === LANGS.ENGLISH){
        row.name = row.nameEnglish;
        row.description = row.descriptionEnglish;
        row.catchcopy = row.catchcopyEnglish;
        row.sound = ''; //英語版は準備していない
      }

      if(row.name == "" || !row.sound){
        //名前がなければ飛ばす
      }
      else{
        elements.push(row);
      }
    }

    return elements;
  };

  const getActiveElement = useCallback(() => {
      let ret = selectedData;
      return ret;
  },[selectedData]);

  if (isLoadingFlowers || isLoadingHistory || isLoadingStation ||
    isFacilityLoading || isToiletLoading || isLoadingBarrierFrees) {
    return (<Loading></Loading>);
  }

  activeAudioGuideList.current = getActiveDataList();

  return (
    <>
    <Header 
      display={true} 
      title={t("audio_guide.title")}/>
    
    <Grid container justifyContent="center" alignItems="center" direction="column">
      <Map ref={mapRef}>
      {
        activeAudioGuideList.current.map((row, fIndex) =>
            row.positions.map((position, pIndex) => {
              let coordinate = [position.latitude, position.longitude];
              let markerKey = getMarkerKey(row, coordinate);
              
              return <Marker
                  key={markerKey}
                  position={coordinate}
                  icon={getIcon(row.markerIcon , row.catchcopy='flower'?AutumnIcon:null)}
                  eventHandlers={{
                    click: (e) => {
                      clickMarker(row, coordinate);
                    }
                  }}
                >
                {
                isActiveMarker(markerKey , row.category)
                //true
                ?<Tooltip
                  {...getTooltipOptions(
                      fIndex + pIndex , 
                      coordinate,
                      row.category
                  )}
                  >
                    {row.name}
                  </Tooltip>
                : <></>
                }
              </Marker>
            })
        )
      }
    </Map>
    <MapCardAudioGuide 
      ref={mapCardRef}
      row={getActiveElement()} 
      isPlaying={isPlayingSound}
      resetMarker={resetMarker} 
   />
  </Grid>
  </>
  )
});
export default AudioGuide